export const WEB_CLIP_MAX_WIDTH_SIZE_PX = 360;
export const WEB_CLIP_MAX_HEIGHT_SIZE_PX = 300;
